import { render } from "./RightArrowIcon.vue?vue&type=template&id=23a6cae1"
const script = {}

import exportComponent from "/home/gavin/dev/sumfo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__